var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row mt-2"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"log-detail mb-3",class:("activity-log-" + _vm.index),domProps:{"innerHTML":_vm._s(_vm.logDetail)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }